// Set the date we're counting down to


var dateParts = window.next_game_start_date.split('/');
var formattedDate = dateParts[1] + '/' + dateParts[0] + '/' + dateParts[2]; // Reformat as "MM/DD/YYYY"
var countDownDate = new Date(formattedDate).getTime();

// console.log(countDownDate);
//this is also for easier testing
// var countDownDate = new Date("August 12, 2023 16:00:00").getTime();

// Get the timezone offset for Cincinnati in milliseconds
var timeZoneOffset = -5 * 60 * 60 * 1000;

// Update the countdown every 1 second

if(jQuery('#countdown').length > 0){
    var x = setInterval(function() {

        // Get the current date and time in Cincinnati
        var now = new Date(Date.now() + timeZoneOffset).getTime();

        // console.log(now, countDownDate);

        // Calculate the distance between now and the countdown date
        var distance = countDownDate - now;
        // console.log(distance);

        // Calculate days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Pad days, hours, minutes and seconds with leading zeros if they are less than 10
        days = (days < 10) ? "0" + days : days;
        hours = (hours < 10) ? "0" + hours : hours;
        minutes = (minutes < 10) ? "0" + minutes : minutes;
        seconds = (seconds < 10) ? "0" + seconds : seconds;

        // Output the result in an element with class="countdown"
        document.querySelector(".days .num").innerHTML = String(days).split("").map(d => `<span class="digit">${d}</span>`).join("");
        document.querySelector(".hours .num").innerHTML = String(hours).split("").map(d => `<span class="digit">${d}</span>`).join("");
        document.querySelector(".minutes .num").innerHTML = String(minutes).split("").map(d => `<span class="digit">${d}</span>`).join("");
        document.querySelector(".seconds .num").innerHTML = String(seconds).split("").map(d => `<span class="digit">${d}</span>`).join("");

        // Add or remove the class "is-active" to style each digit based on its value
        document.querySelectorAll(".digit").forEach(digit => {
          digit.classList.toggle("is-active", parseInt(digit.innerHTML) > 0);
        });

      // If the countdown is finished, display "EXPIRED"
      if (distance < 0) {
        clearInterval(x);
        document.getElementById("countdown").innerHTML = "EXPIRED";
      }
    }, 1000);
}
